import React, { Component } from 'react'
import ActivityList from 'components/activity-list/activity-list'

import { connect } from 'react-redux'

import {
    getPulseData
} from 'state/actions'

import { forEachRight, forEach } from 'lodash'
import copy from 'fast-copy'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import Icon from 'components/icon/icon'

import moment from 'moment'

import { Line } from 'react-chartjs-2'
import { accentColour } from 'env'

import Loader from 'components/loader/loader'

class ProjectPulse extends Component {
    state = {
        isLoadingPulseData: true,
        isLoadingDayData: false,
        pulseData: {},
        selectedDayIndex: -1,
        validUserIds: [],
        selectedUserId: null,
        reRenderKey: 0
    }

    chartData = null
    shouldRenderOnComplete = true
    
    componentDidMount() {
        this.generateChartData()
        this.queryPulseData()
    }

    queryPulseData = (selectedUserId = null) => {
        const {
            project,
            getPulseData
        } = this.props

        this.setState({
            selectedUserId,
            isLoadingPulseData: true,
        })

        if(project && project.id){
            getPulseData(project.id, selectedUserId, pulseData => {
                this.setState({
                    pulseData: {
                        ...this.state.pulseData,
                        [selectedUserId]: pulseData.data,
                    },
                    validUserIds: pulseData.userIds,
                    isLoadingPulseData: false
                })

                this.generateChartData()
            })
        }else{
            this.setState({
                isLoadingPulseData: false
            })
        }  

    }

    getCurrentPulseData = _ => {
        const {
            pulseData,
            selectedUserId
        } = this.state

        if(pulseData && pulseData[selectedUserId]){
            return pulseData[selectedUserId]
        }else{
            return null
        }
    }

    generateChartData = _ => {
        let pulseData = this.getCurrentPulseData()

        const {
            project,
            userData
        } = this.props

        if(!pulseData){
            pulseData = []
        }

        let mostRecentIndex = -1

		let chartData = {
			labels: [],
			datasets: [{
				fill: false,
				borderColor: accentColour(),
                borderWidth: 3,
                pointHitRadius: 20,
                pointBorderWidth: 1,
				pointRadius: 0, // set this to 6 if i have any data (or it's today)
				backgroundColor: (userData && userData.show_dark_ui) ? '#999' : 'white',
				data: []
			}]
		}

        //const totalDayRange = moment(pulseData[(pulseData.length - 1)].date).diff(moment(pulseData[0].date), 'days')

        let hasGottenToLatestDate = false
        let dayIndex = 0
        let isLatestDateToday = false

        let earliestDate = pulseData.length ? moment(pulseData[0].date) : moment()
        let latestDate = pulseData.length ? moment(pulseData[(pulseData.length - 1)].date) : moment()

        if(moment().isAfter(latestDate)){
            isLatestDateToday = true
            latestDate = moment()
        }

        if(project.start_date && moment(project.start_date).isBefore(earliestDate)){
            earliestDate = moment(project.start_date)
        }

        if(project.end_date && moment(project.end_date).isAfter(latestDate)){
            latestDate = latestDate
        }

        const datesToShow = 30

        const totalDayRange = latestDate.diff(earliestDate, 'days')

        const minimumDatesDelta = datesToShow - totalDayRange

        if(totalDayRange < 30){

            if(minimumDatesDelta > 0){
                latestDate.add(minimumDatesDelta, 'days')
            }
        }else{
            earliestDate.add(Math.abs(minimumDatesDelta), 'days')            
        }

        earliestDate.subtract(1, 'day')

        const today = latestDate.format('YYYY-MM-DD')

        let max = 0

        while(!hasGottenToLatestDate){
            const momentToCheck = earliestDate.clone().add(dayIndex, 'days')
            const dayToCheck = momentToCheck.format('YYYY-MM-DD')

            if(isLatestDateToday && momentToCheck.isSame(moment(), 'day')){
                mostRecentIndex = dayIndex
            }

            let activities = 0

            pulseData.some(pulseday => {
                if(pulseday.date == dayToCheck){
                    activities = pulseday.activities

                    return true
                }
            })

            if(activities){
                mostRecentIndex = dayIndex
            }

            if(activities > max){
                max = activities
            }

			chartData.labels.push(momentToCheck.format('MMMM D, YYYY'))
            chartData.datasets[0].data.push(activities)

            if(today === dayToCheck){
                hasGottenToLatestDate = true
            }

            dayIndex++

            if(dayIndex > 300){
                hasGottenToLatestDate = true
            }
        }

		const gridData = copy(chartData)

		gridData.datasets[0].borderColor = 'transparent'
        gridData.datasets[0].pointBackgroundColor = 'transparent'

        const normalisedMostRecentIndex = (dayIndex - mostRecentIndex - 1)

        this.chartData = {
            chartData,
            gridData,
            max,
            earliestDate,
            latestDate,
            normalisedMostRecentIndex
        }

        this.shouldRenderOnComplete = true

        const newState = {
            reRenderKey: this.state.reRenderKey + 1
        }

        if(this.state.selectedDayIndex == -1 && pulseData.length){
            newState.selectedDayIndex = normalisedMostRecentIndex
        }

        this.setState(newState)
    }

    handlePointClick = event => {
        if(event.length && this.chartData){
            if(event[0] && event[0].custom && event[0].custom.radius){
                const index = event[0]._index
                const reversedIndex = (this.chartData.chartData.labels.length - 1) - index

                this.changeDay(reversedIndex, true)
            }
        }
    }

    selectDate = (dayIndex, isRemove) => {
        window.requestAnimationFrame(_ => {
            if(this.chartData && this.chartRef){
                const {
                    chartData
                } = this.chartData

                const reversedIndex = (chartData.labels.length - 1) - dayIndex

                chartData.datasets[0].data.forEach((dataPoint, index) => {
                    let dayLabel = chartData.labels[index]

                    const thisDay = moment(dayLabel).startOf('day')
                    const isToday = thisDay.isSame(moment(), 'day') //.isToday()

                    if(dataPoint || isToday){
                        const customPoint = isRemove ? null : {
                            radius: 6
                        }

                        if(!isRemove && reversedIndex === index){
                            customPoint.borderColor = accentColour()
                            customPoint.backgroundColor = accentColour()
                        }

                        this.chartRef.chartInstance.getDatasetMeta(0).data[index].custom = customPoint
                    }
                })


                this.chartRef.chartInstance.update()
            }
        })
    }

    handleChangeUser = userId => {
        this.queryPulseData(userId > 0 ? userId : null)
    }

    changeDay = (type, canChange) => {
        if(!canChange){
            return 
        }

        const dataPoints = this.chartData.chartData.datasets[0].data

        const currentDayIndex = this.state.selectedDayIndex
        let selectedDayIndex = -1

        this.selectDate(currentDayIndex, true)

        if(typeof type == 'number'){
            selectedDayIndex = type
        }else{
            switch(type){
                case 'prev':
                    let index = 0
                    
                    forEachRight(dataPoints, point => {
                        if(point && index > currentDayIndex && selectedDayIndex == -1){
                            selectedDayIndex = index
                        }
                        index++
                    })
                    break
                case 'next':
                    const normalisedCurrentDayIndex = dataPoints.length - currentDayIndex - 1
                    
                    forEach(dataPoints, (point, index) => {
                        if(point && index > normalisedCurrentDayIndex && selectedDayIndex == -1){
                            selectedDayIndex = index
                        }
                        index++
                    })

                    if(selectedDayIndex === -1){
                        selectedDayIndex = 0
                    }else{
                        selectedDayIndex = dataPoints.length - selectedDayIndex - 1
                    }
                    break
                case 'end':
                    selectedDayIndex = 0
                    break
            }
        }

        this.selectDate(selectedDayIndex)

        this.setState({
            selectedDayIndex
        })
    }

    getApplicableUsers = _ => {
        const {
            allUsers
        } = this.props

        const {
            validUserIds
        } = this.state

        const applicableUsers = []

        if(validUserIds){
            validUserIds.forEach(userId => {
                const user = allUsers[userId]

                if(user){
                    applicableUsers.push(user)
                }
            })
        }

        return applicableUsers
    }

    hasPreviousDay = selectedMoment => {
        const {
            chartData
        } = this.chartData

        let earliestMoment = null

        chartData.datasets[0].data.some((dataPoint, index) => {
            if(dataPoint){
                earliestMoment = moment(chartData.labels[index])

                return true
            }
        })

        if(earliestMoment){
            return earliestMoment.startOf('day').isBefore(selectedMoment.startOf('day'))
        }

        return false
    }

    setLoading = isLoadingDayData => {
        this.setState({
            isLoadingDayData
        })
    }
    
    render() {
        const {
            project,
        } = this.props

        const {
            selectedDayIndex,
            selectedUserId,
            reRenderKey,
            isLoadingPulseData,
            isLoadingDayData
        } = this.state

        if(!this.chartData){
            return null
        }

        const applicableUsers = this.getApplicableUsers()

        const {
            chartData,
            gridData,
            max,
            latestDate,
            normalisedMostRecentIndex
        } = this.chartData

        let adjustedMax = max ? (max + 3) : 6

		const options = {
            tooltips: {
                displayColors: false,
                callbacks: {
                    label: tooltipItems => {  
                        const {
                            value
                        } = tooltipItems

                        return `${value} activit${value == '1' ? 'y' : 'ies'}`
                    }
                }
            },
            maintainAspectRatio: false,
            layout: {
                padding: {
                    left: 0,
                    right: 15,
                    top: 0,
                    bottom: 0
                }
            },
            animation: {
                onComplete: _ => {
                    if(this.shouldRenderOnComplete){
                        this.shouldRenderOnComplete = false

                        this.selectDate(selectedDayIndex)
                    }
                }
            },
			axes: {
				display: false
			},
			legend: {
				display: false
			},
			scales: {
				yAxes: [{
					display: false,
					ticks: {
						max: adjustedMax,
						min: -1,
						stepSize: 1
					}
				}],
				xAxes: [{
					display: false,
					ticks: {
						beginAtZero: true
					}
				}]
			}
        }

		const gridOptions = {
			...options,
			tooltips: {
				enabled: false
			},
			scales: {
				ticks: {
					beginAtZero: true,
				},
				yAxes: [{
					ticks: {
						display: false,
						max: adjustedMax,
						min: -1,
						stepSize: adjustedMax > 80 ? 5 : 1,
					},
					gridLines: {
						color: 'white',
						tickMarkLength: 0,
                        zeroLineColor: 'white'
					}
				}],
				xAxes: [{
					tickMarkLength: 0,
					ticks: {
						display: false,
                        beginAtZero: true,
					},
					gridLines: {
						color: 'white',
						tickMarkLength: 0,
						offsetGridLines: true,
                        zeroLineColor: 'white'
					}
				}]
			}
        }

        const isLastDay = normalisedMostRecentIndex == selectedDayIndex

        const selectedDate = latestDate.clone().subtract(selectedDayIndex, 'days')
        const hasPreviousDay = this.hasPreviousDay(selectedDate)

        let className = 'widget box project-pulse'

        if(isLoadingPulseData){
            className += ' loading'
        }

        if(isLoadingDayData){
            className += ' loading-day'
        }

        return (
            <div className={className}>
                <h3>
                    Project Pulse
                </h3>
                <div className="controls relative">
                    <div className='folder-selector-dropdown-container visible'>
                        <DropdownMenu
                            parentType="user"
                            parentKey="user_id"
                            selectableItems={applicableUsers}
                            isObjects={true}
                            selectedItemId={selectedUserId}
                            handleChange={this.handleChangeUser}
                            hasSearch={true}
                            hasAll={true}
                        />
                    </div>
                </div>
                <div className="canvas-container" >
                    <Line 
                        data={chartData} 
                        options={options} 
                        onElementsClick={this.handlePointClick}
                        ref={ref => this.chartRef = ref}
                        height={400}
                        key={reRenderKey}
                    />
                </div>
                <div className="canvas-container">
                    <Line 
                        data={gridData} 
                        options={gridOptions} 
                        height={400}
                    />
                </div>
                <div className="activity-list-controls">
                    <h4>
                        { selectedDate.format('dddd, MMMM D') }
                        <div className="header-tab-controls">
                            <button 
                                className={hasPreviousDay ? 'active' : null} 
                                onClick={_ => {this.changeDay('prev',hasPreviousDay)}}
                            >
                                <Icon name="angle-left" />
                                <span>
                                    Back
                                </span>
                            </button>
                            <button 
                                className={!isLastDay ? 'active' : null} 
                                onClick={_ => {this.changeDay('end',!isLastDay)}}
                            >
                                <Icon name="angle-right" />
                            </button>
                            <button 
                                className={!isLastDay ? 'active' : null} 
                                onClick={_ => {this.changeDay('next',!isLastDay)}}
                            >
                                <span>
                                    Forward
                                </span>
                                <Icon name="angle-right" />
                            </button>
                        </div>
                    </h4>
					<Loader visible={true} />
				    <ActivityList 
					    context="project" 
                        projectId={project.id} 
                        isPulse={true}
                        selectedDate={selectedDate.startOf('day')}
                        selectedUserId={selectedUserId}
                        setLoading={this.setLoading}
				    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        allUsers: state.account.entities.users
    }
}

export default connect(mapStateToProps, {
    getPulseData
}) (ProjectPulse)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-reporting/project-pulse.jsx